import { AISystemEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const createAISystems = async (data: any): Promise<any> =>
  APIManager.sendPost(AISystemEnds.POST_AISOLUTIONS, data, true, {}, {}, axios);

const getAISystems = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    AISystemEnds.GET_AISOLUTIONS(queryString),
    true,
    {},
    {},
    axios
  );

const getAISystemDetail = async (id: string): Promise<any> =>
  APIManager.sendGet(AISystemEnds.AISOLUTIONS_DETAIL(id), true, {}, {}, axios);

const linkDataset = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(AISystemEnds.LINK_DATASET(id), data, true, {}, {}, axios);

const updateAISystems = async (id: any, data: any): Promise<any> =>
  APIManager.sendPut(
    AISystemEnds.UPDATE_AISOLUTIONS(id),
    data,
    true,
    {},
    {},
    axios
  );

const deleteAISystems = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    AISystemEnds.DELETE_AISOLUTIONS(id),
    true,
    {},
    {},
    axios
  );

const approveAISystem = async (
  data: any,
  id: string,
  status: string
): Promise<any> =>
  APIManager.sendPut(
    AISystemEnds.UPDATE_AISOLUTIONS_STATUS(id, status),
    data,
    true,
    {},
    {},
    axios
  );

const getFeedbackList = async (id: string): Promise<any> =>
  APIManager.sendGet(AISystemEnds.GET_FEEDBACK(id), true, {}, {}, axios);

const updateFeedback = async (id: string, isReviewed: boolean): Promise<any> =>
  APIManager.sendPut(
    AISystemEnds.UPDATE_FEEDBACK(id, isReviewed),
    {},
    true,
    {},
    {},
    axios
  );

const getSummaryCount = async (): Promise<any> =>
  APIManager.sendGet(AISystemEnds.AI_SUMMARY, true, {}, {}, axios);

const createComment = async (data: any): Promise<any> =>
  APIManager.sendPost(AISystemEnds.POST_COMMENT, data, true, {}, {}, axios);

const getComments = async (
  entityType: string,
  entityId: string
): Promise<any> =>
  APIManager.sendGet(
    AISystemEnds.GET_COMMENTS(entityType, entityId),
    true,
    {},
    {},
    axios
  );

const updateComment = async (commentId: string, data: any): Promise<any> =>
  APIManager.sendPut(
    AISystemEnds.UPDATE_COMMENT(commentId),
    data,
    true,
    {},
    {},
    axios
  );

const deleteComment = async (commentId: string): Promise<any> =>
  APIManager.sendDelete(
    AISystemEnds.DELETE_COMMENT(commentId),
    true,
    {},
    {},
    axios
  );

const bulkCreate = async (data: any): Promise<any> =>
  APIManager.sendPost(AISystemEnds.BULK_UPLOAD, data, true, {}, {}, axios);

const createSBOM = async (data: any): Promise<any> =>
  APIManager.sendPost(AISystemEnds.TOOLS, data, true, {}, {}, axios);

const getSBOM = async (aiSystemId: any): Promise<any> =>
  APIManager.sendGet(AISystemEnds.GET_TOOLS(aiSystemId), true, {}, {}, axios);

const deleteSBOM = async (sbomId: string): Promise<any> =>
  APIManager.sendDelete(AISystemEnds.DELETE_TOOL(sbomId), true, {}, {}, axios);

const getAISystemsApprovalGate = async (id: string): Promise<any> =>
  APIManager.sendGet(
    AISystemEnds.AI_APPROVAL_GATE_BY_ID(id),
    true,
    {},
    {},
    axios
  );

const createUpdateAIApprovalGate = async (data: any): Promise<any> =>
  APIManager.sendPost(
    AISystemEnds.AI_CREATE_UPDATE_APPROVAL_GATE,
    data,
    true,
    {},
    {},
    axios
  );

const getAISystemTEVVHistory = async (id: string): Promise<any> =>
  APIManager.sendGet(
    AISystemEnds.GET_HISTORY_AISYSTEM_TEVV(id),
    true,
    {},
    {},
    axios
  );

const getAISystemFailureHistory = async (id: string): Promise<any> =>
  APIManager.sendGet(
    AISystemEnds.GET_HISTORY_AISYSTEM_SYSTEM_FAILURE(id),
    true,
    {},
    {},
    axios
  );

export const AISystemsService = {
  createAISystems,
  getAISystems,
  getAISystemDetail,
  linkDataset,
  updateAISystems,
  deleteAISystems,
  approveAISystem,
  getFeedbackList,
  updateFeedback,
  getSummaryCount,
  createComment,
  getComments,
  updateComment,
  deleteComment,
  bulkCreate,
  createSBOM,
  getSBOM,
  deleteSBOM,
  getAISystemsApprovalGate,
  createUpdateAIApprovalGate,
  getAISystemTEVVHistory,
  getAISystemFailureHistory,
};
